import { render, staticRenderFns } from "@/style-guide/partials/emptyState/emptyState.pug?vue&type=template&id=86d0c00c&scoped=true&lang=pug&external"
import script from "./emptyState.vue?vue&type=script&lang=ts"
export * from "./emptyState.vue?vue&type=script&lang=ts"
import style0 from "./emptyState.vue?vue&type=style&index=0&id=86d0c00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d0c00c",
  null
  
)

export default component.exports